import React,{useState,useEffect} from 'react';
import {connect} from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js';
import Navbar from './Navbar';
import AutoLogout from './AutoLogout';
import RobotCheck from './RobotCheck';
import MailVerify from './MailVerify';
import PasswordChange from './PasswordChange';
import axios from 'axios';
import {checkCode,logout,retryFailed,clearErrors} from '../store/authActions';

const ResetPage = ({history,robot,validMail,mailToken,codeVerified,checkCode,logout,retryFailed,clearErrors,passwdUpdated,passwdError,userid}) => {
  const [token, setToken] = useState('');
  const [count, setCount] = useState(1);

  useEffect(()=>{
    if(!validMail) setToken('');
  },[validMail]);

  useEffect(()=>{
    if(userid){
      const n = Number(userid.uidNumber);
      if(n && (n<1500000 || n>3000000)){
        logout();
        history.push('/');
      }
    }
  //eslint-disable-next-line
  },[userid]);

  useEffect(()=>{
    if(codeVerified===false){
      M.toast({html: `Verification code not valid, attempt: ${count} / 3`, classes: 'red darken-2', displayLength: 5000});
      setCount(count+1);
      if(count>=3){
        retryFailed();
        setCount(1);
        M.toast({html: `please try again or contact support`, classes: 'orange darken-1', displayLength: 5000});
      }
      clearErrors();
      setToken('');
    }
  //eslint-disable-next-line
  },[codeVerified]);

  const onChange = (e) => setToken(e.target.value)
  const onSubmit = (e) => {
    e.preventDefault();
    axios.defaults.headers.common['x-auth-token']=mailToken;
    checkCode({mailcode:token});
  };
  const onOkClick = () => {
    logout();
    history.push('/');
  };

  return (
    <>
      <Navbar title={'Portal Password Reset'} />
      { codeVerified && <AutoLogout /> }

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      <RobotCheck />

      <div style={{'margin':'50px 0px 50px 0px'}}></div>
      { !robot && <MailVerify /> }

      <div className='container form-container'>
        { validMail && !codeVerified &&
          <form onSubmit={onSubmit}>
            <div className='form-group'>
              <label htmlFor='token'>Email verification code</label>
              <input type='text' name='token' value={token} onChange={onChange} required />
            </div> 
            <input type='submit' value='Verify' className='btn btn-primary btn-block' />
          </form>
        }
        { codeVerified && <PasswordChange /> }
        { (passwdUpdated||passwdError) &&
          <div className='container'>
            <p>Click OK to return or close this window</p>
            <button className='btn btn-primary btn-block' onClick={onOkClick}>OK</button>
          </div>
        }
      </div>
    </>
  );
};

const mapStoreToProps = state => ({
  robot: state.auth.robot,
  validMail: state.auth.validMail,
  mailToken: state.auth.mailToken,
  codeVerified: state.auth.codeVerified,
  passwdUpdated: state.auth.passwdUpdated,
  passwdError: state.auth.passwdError,
  userid: state.auth.userid
});

export default connect(mapStoreToProps,{checkCode,logout,retryFailed,clearErrors})(ResetPage)

